import { S1PythonLogEntry } from "./s1-pythonlogentry";

export class S1PythonActivityReport {
    failed : boolean;
    log? : S1PythonLogEntry[];
    trace? : string;
}